module.exports = __webpack_public_path__ + "static/media/hand-pointer.c1ab9f53.svg";